import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './pages/Opportunities.translations'

const routes = (): RouteRecordRaw[] => {
  return [
    {
      component: () => import('~/scopes/opportunities/pages/Opportunities.vue'),
      redirect: { name: ROUTE_NAMES.OPPORTUNITIES.PRICING },
      name: ROUTE_NAMES.OPPORTUNITIES.INDEX,
      path: '/bo-seller/opportunities',
      meta: {
        autonomousBannerPageName: 'opportunities',
        owners: ['bot-squad-seller-experience-front'],
      },
      children: [
        {
          name: ROUTE_NAMES.OPPORTUNITIES.PRICING,
          component: () =>
            import('~/scopes/opportunities/pages/tabs/pricing/Pricing.vue'),
          path: 'pricing',
          meta: {
            autonomousBannerPageName: 'opportunities.pricing',
            tabItem: {
              label: translations.pricingTab,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import('~/scopes/opportunities/pages/tabs/inventory/Inventory.vue'),
          name: ROUTE_NAMES.OPPORTUNITIES.INVENTORY,
          path: 'inventory',
          meta: {
            autonomousBannerPageName: 'opportunities.inventory',
            tabItem: {
              label: translations.inventoryTab,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import('~/scopes/opportunities/pages/tabs/deals/Deals.vue'),
          name: ROUTE_NAMES.OPPORTUNITIES.DEALS,
          path: 'deals',
          meta: {
            autonomousBannerPageName: 'opportunities.deals',
            tabItem: {
              label: translations.dealsTab,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
      ],
    },
  ]
}

export default routes
